import { useLocation, useNavigate } from "fusion-plugin-react-router";
import { assetsPath } from "../../../../shared/utils/assetsPath";

const LandingSidebar = ({ menuItems }) => {
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <aside className="portal-menu">
      <ul>
        {menuItems.map((menu) => (
          <li
            key={menu.name}
            className={`portalMenuHeading ${
              location.pathname === menu.route ? "selected-tab" : "default-tab"
            }`}
            onClick={() => {
              if (menu.route) {
                navigate(menu.route);
              } else {
                menu.action();
              }
            }}
          >
            <img
              src={
                location.pathname === menu.route
                  ? menu.icon
                  : assetsPath.grayHeart
              }
              alt={`${menu.name} icon`}
            />
            <h5 className="menuHeading font-16 margin-y-0">{menu.name}</h5>
          </li>
        ))}
      </ul>
    </aside>
  );
};

export default LandingSidebar;
